(() => {
    
    const loadGTag = () => {
        // let a = document.createElement('script');
        // a.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=AW-960320358');

        // a.onload = () => {
        //     window.dataLayer = window.dataLayer || [];
        //     function gtag() { dataLayer.push(arguments); }
        //     gtag('js', new Date());

        //     gtag('config', 'AW-960320358');
        // };
        // document.head.insertAdjacentElement("beforeend", a);

        // let s = document.createElement('script');
        // s.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=UA-18240032-2');

        // s.onload = () => {
        //     window.dataLayer = window.dataLayer || [];
        //     function gtag() { dataLayer.push(arguments); }
        //     gtag('js', new Date());

        //     gtag('config', 'UA-18240032-2', { 'optimize_id': 'GTM-5GN32BT' });
        // };
        // document.head.insertAdjacentElement("beforeend", s);
    };

    const loadFreshChat = () => {
        function initialize(i, t) { var e; i.getElementById(t) ? initFreshChat() : ((e = i.createElement("script")).id = t, e.async = !0, e.src = "https://wchat.freshchat.com/js/widget.js", e.onload = initFreshChat, i.head.appendChild(e)) }
        function initiateCall() { initialize(document, "freshchat-js-sdk") }
        window.addEventListener ? window.addEventListener("load", initiateCall, !1) : window.attachEvent("load", initiateCall, !1);
    };

    const loadCustomScripts = () => {
        window.custom_scripts.forEach(script => {
            let s = document.createElement('script');
            s.setAttribute('src', script);
            document.head.insertAdjacentElement("beforeend", s);
        });
    };

    const loadGoogleReviews = () => {
        let a = document.createElement('script');
        a.setAttribute('src', 'https://apis.google.com/js/platform.js?onload=renderOptIn');
        document.head.insertAdjacentElement("beforeend", a);
    };

    const loadWLM = () => {
        let a = document.createElement('script');
        a.setAttribute('src', 'https://www.cobra.com/apps/wlm/js/wlm-1.1.js');
        
        a.onload = () => {
            setTimeout(() => {
                document.dispatchEvent(new CustomEvent('WLMLoaded'));
            }, 500);
        };
        document.head.insertAdjacentElement("beforeend", a);
    };


    const loadYotpo = () => {
        (function e() {
            var e = document.createElement("script");
            e.type = "text/javascript", e.async = true, e.src = "//staticw2.yotpo.com/H3HiG7bhAapgSgkzLXpJZbTv05ESDnomGxanJnvI/widget.js";
            var t = document.getElementsByTagName("script")[0];
            t.parentNode.insertBefore(e, t)
        })();
    };

    const loadTiktok = () => {
        !function (w, d, t) {
            w.TiktokAnalyticsObject = t; var ttq = w[t] = w[t] || []; ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie"], ttq.setAndDefer = function (t, e) { t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))) } }; for (var i = 0; i < ttq.methods.length; i++)ttq.setAndDefer(ttq, ttq.methods[i]); ttq.instance = function (t) {
                for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++
                )ttq.setAndDefer(e, ttq.methods[n]); return e
            }, ttq.load = function (e, n) { var i = "https://analytics.tiktok.com/i18n/pixel/events.js"; ttq._i = ttq._i || {}, ttq._i[e] = [], ttq._i[e]._u = i, ttq._t = ttq._t || {}, ttq._t[e] = +new Date, ttq._o = ttq._o || {}, ttq._o[e] = n || {}; n = document.createElement("script"); n.type = "text/javascript", n.async = !0, n.src = i + "?sdkid=" + e + "&lib=" + t; e = document.getElementsByTagName("script")[0]; e.parentNode.insertBefore(n, e) };

            ttq.load('CE91ALRC77UA35R4J3IG');
            ttq.page();
        }(window, document, 'ttq');
    };
    const addCartOpenListener = () => {

        document.addEventListener('cart:open', () => {
            console.log('cart is opened')
            //trigger cart listener for google optimize
            let cartMini = document.getElementById('mini-cart')
            let cartItems = cartMini = cartMini.querySelectorAll('[data-item]');
            console.log(cartMini, cartItems)
            const triggerOptimize = () => { dataLayer.push({'event': 'optimize.subs_in_cart'});}
            let itemsHasSubs = [];
            let itemsHasRadar = [];
            cartItems.forEach(item => {
                if (cartItems.length == 1){
                    if ( item.getAttribute('data-item').includes('DualPro') || item.getAttribute('data-item').includes('Road Scout')){
                        itemsHasSubs.push(true)
                    }
                }
                //check for radar
                if (item.querySelector('[data-property="Subscription"]')){
                    itemsHasRadar.push(true)
                }
            })
            if (itemsHasSubs.length == 0 && itemsHasRadar.length > 0){
                console.log('test triggering')
                triggerOptimize();
            }
        })
    }
    const loadScripts = () => {
        loadFreshChat();
        // loadGTag();
        loadGoogleReviews();
        loadWLM();
        loadYotpo();
        loadTiktok();
        loadCustomScripts();
        addCartOpenListener();
    };

    document.addEventListener('UserInteracted', loadScripts, false);
})();